import AxiosPermisos  from './../axiosPermisos'
import { path } from './path'

async function getOutSourcedExport (date = '') {
  return await AxiosPermisos.get(`${path.outSourcedExport}?date=${date}`, true)
}

async function getDirectExport(date = '') {
  return await AxiosPermisos.get(`${path.directExport}?date=${date}`, true)
}

async function getConsolidatedTipsExport(date = '') {
  return await AxiosPermisos.get(`${path.consolidatedTipsExport}?date=${date}`, true)
}

export { getOutSourcedExport, getDirectExport, getConsolidatedTipsExport }